import { Box, Container, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';

function TermsPage() {
  return (
    <Box 
      sx={{ 
        bgcolor: '#000000',
        minHeight: '100vh',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowX: 'hidden'
      }}
    >
      <Header />
      <Box
        sx={{
          pt: '84px',
          pb: '100px'
        }}
      >
        <Container 
          maxWidth="md"
          sx={{
            color: 'white',
            p: { xs: 2, sm: 4 }
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              color: '#ff0000',
              fontWeight: 600,
              mb: 4,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              textShadow: '0 0 10px rgba(255, 0, 0, 0.3)'
            }}
          >
            Terms of Service – Screamify™
          </Typography>

          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            Welcome to Screamify™. By using our website, purchasing products, or accessing any of our services, you agree to the following Terms of Service. Please read them carefully.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            1. Use of Our Site
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            You agree to use Screamify™ only for lawful purposes and in accordance with these Terms. You must be at least 18 years old or have the permission of a parent/guardian to use this site.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            2. Products and Services
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            Screamify™ sells branded merchandise, including limited-edition hats, to fund independent horror film productions. All proceeds go directly toward producing indie horror films. We reserve the right to modify or discontinue products at any time without notice.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            3. User Accounts
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            If you create an account with us, you are responsible for maintaining the confidentiality of your login information. You agree to notify us immediately of any unauthorized use of your account.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            4. Intellectual Property
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            All content on this site, including but not limited to text, images, logos, and videos, is the property of Screamify™ and is protected by copyright and trademark laws.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            5. Limitation of Liability
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            Screamify™ is not liable for any indirect, incidental, or consequential damages arising from your use of the website or products.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            6. Geographic Restrictions and Location Masking
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            Due to licensing agreements and distribution rights, certain content on Screamify™ may only be available in specific geographic regions. By using our service, you agree not to use VPNs, proxy servers, or other methods to mask or misrepresent your actual geographic location. Attempting to circumvent geographic restrictions may result in account suspension or termination. We reserve the right to use technical measures to detect and prevent location masking.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            7. Changes to Terms
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            We reserve the right to update or change these Terms at any time. Continued use of our site following any changes means you accept the new terms.
          </Typography>

          <Typography variant="h6" sx={{ color: '#ff0000', mt: 4, mb: 2 }}>
            Contact
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mb: 3 }}>
            If you have any questions about these Terms, please contact us at: info@screamify.com
          </Typography>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default TermsPage; 